import styled from "styled-components";

export const ArtistLinkWrapper = styled.div`

`;
